"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _core = require("@material-ui/core");
var _Auth = require("../../contexts/Auth");
var _styles = _interopRequireDefault(require("./styles"));
var _CopyDiv = _interopRequireDefault(require("./CopyDiv"));
var _Pdf = _interopRequireDefault(require("../../api/Pdf"));
var _Copy = _interopRequireDefault(require("../../api/Copy"));
var _Copy2 = _interopRequireDefault(require("../../services/Copy"));
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var CopyDialog = _ref => {
  var {
    copyDialog,
    setCopyDialog,
    copyContent,
    pdf,
    setCopyContent,
    origin,
    copyValue,
    setCopyValue
  } = _ref;
  var [isFirstCopy, setIsFirstCopy] = (0, _react.useState)(true);
  var [reference, setReference] = (0, _react.useState)('');
  var [referencePage, setReferencePage] = (0, _react.useState)();
  var [author, setAuthor] = (0, _react.useState)('');
  var [editionYear, setEditionYear] = (0, _react.useState)();
  var HASH = 'copy-text';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var {
    auth
  } = (0, _Auth.useAuth)();
  var classes = (0, _styles.default)();
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setCopyDialog(false);
        setIsFirstCopy(true);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setCopyDialog, setCopyContent]);
  (0, _react.useEffect)(() => {
    if (copyDialog) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [copyDialog, setCopyDialog]);
  function onCopy(_x) {
    return _onCopy.apply(this, arguments);
  }
  function _onCopy() {
    _onCopy = _asyncToGenerator(function* (value) {
      var {
        applicationToken,
        sessionToken,
        userId,
        uuid
      } = auth;
      if (!isFirstCopy) return;
      setIsFirstCopy(false);
      var totalLength = yield _PdfReader.default.getAllContentFromPdf(pdf);
      var remainingChars = yield _Copy2.default.getRemainingChars(applicationToken, sessionToken, userId, uuid, totalLength.length);
      var totalCharacters = totalLength.length;
      var chars = value.length > remainingChars ? remainingChars : value.length;
      var payload = {
        user_id: userId,
        book_id: uuid,
        total_char_copied: chars,
        total_char_book: totalCharacters
      };
      yield _Copy.default.setCharactersCopied(applicationToken, sessionToken, payload);
      var newCopyValue = yield _Copy2.default.getPercentageCharsCopied(applicationToken, sessionToken, userId, uuid, totalLength.length);
      setCopyValue(parseInt(newCopyValue));
    });
    return _onCopy.apply(this, arguments);
  }
  (0, _react.useEffect)(() => {
    var {
      applicationToken,
      sessionToken,
      uuid
    } = auth;
    _Pdf.default.getBook(applicationToken, sessionToken, uuid).then(data => setEditionYear(data.editionYear));
    _Pdf.default.getBook(applicationToken, sessionToken, uuid).then(data => setAuthor(data.abnt.split(' ')[0]));
    setReferencePage(copyContent === null || copyContent === void 0 ? void 0 : copyContent.text_reference.position.pageNumber);
    setReference(copyContent === null || copyContent === void 0 ? void 0 : copyContent.text_reference.content.text);
  }, [auth, copyContent]);
  function onClose() {
    setCopyDialog(false);
    setIsFirstCopy(true);
    setCopyContent();
  }
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    open: copyDialog,
    size: "md",
    title: "Copiar",
    primaryButton: "fechar",
    handleConfirm: onClose,
    handleClose: onClose,
    confirmWithoutCheck: onClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    onContextMenu: e => e.preventDefault(),
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_CopyDiv.default, {
    author: author,
    editionYear: editionYear,
    referencePage: referencePage,
    pdf: pdf,
    title: "Trecho selecionado",
    reference: reference === null || reference === void 0 ? void 0 : reference.trim(),
    onCopy: onCopy,
    origin: origin
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_CopyDiv.default, {
    author: author,
    editionYear: editionYear,
    referencePage: referencePage,
    pdf: pdf,
    abntProp: true,
    title: "Cita\xE7\xE3o direta norma ABNT",
    reference: reference === null || reference === void 0 ? void 0 : reference.trim(),
    onCopy: onCopy,
    origin: origin
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.label : classes.labelMobile
  }, "Limite de c\xF3pia deste livro"), copyValue ? /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    className: classes.bar,
    size: "full",
    color: "secondary",
    small: true,
    value: copyValue,
    limit: true
  }) : /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    className: classes.bar,
    size: "full",
    color: "secondary",
    small: true,
    value: 0,
    limit: true
  })));
};
var _default = exports.default = CopyDialog;